import api, { METHODS } from './api'
import { ResponseType } from '../common/types/api/request'

export default async function setOneEmailForRecipientGroupFlag(oneEmailForRecipientGroupFlag: boolean): Promise<ResponseType> {
    try {
        const res = await api<ResponseType>(
            `oneEmailForRecipientGroupFlag`, // for apache servers
            METHODS.POST,
            `${oneEmailForRecipientGroupFlag}`
        )

        if (res.error) {
            console.error("Error trying to save new value for the flag to send one email for recipient group in reports-maker", res.error)

            return {
                success: false,
                error: res.error
            }
        }

        return res
        
    } catch (error) {
        // TODO: use logger
        // console.error(error)
        console.error("Error trying to save new value for the flag to send one email for recipient group in reports-maker", error)
        return {
            success: false,
            error: error
        }
    }
}